<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'Testimonials',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Testimonials.vue